import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/SearchPage';
import { BookPage } from './pages/BookPage';
import { BookingConfirmationPage } from './pages/BookingConfirmationPage';
import { ManagePage } from './pages/ManagePage';
import { LoginPage } from './pages/LoginPage';
import { MilesPage } from './pages/MilesPage';
import { GuidePage } from './pages/GuidePage';
import { FleetPage } from './pages/FleetPage';
import { DestinationsPage } from './pages/DestinationsPage';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="book" element={<BookPage />} />
        <Route path="booking/confirmation" element={<BookingConfirmationPage />} />
        <Route path="manage" element={<ManagePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="miles" element={<MilesPage />} />
        <Route path="guide/fleet" element={<FleetPage />} />
        <Route path="guide/:slug" element={<GuidePage />} />
        <Route path="destinations/:kind" element={<DestinationsPage />} />
      </Route>
    </Routes>
  );
}
